import { render, staticRenderFns } from "./ConsentView.vue?vue&type=template&id=6fc23143&scoped=true"
import script from "./ConsentView.vue?vue&type=script&lang=js"
export * from "./ConsentView.vue?vue&type=script&lang=js"
import style0 from "./ConsentView.vue?vue&type=style&index=0&id=6fc23143&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc23143",
  null
  
)

export default component.exports